/*
 * crioh-cart-busy.js
 * Marca <html> con atributos de "ocupado" mientras hay peticiones en vuelo, para
 * dar feedback visual (todo el efecto es CSS que reacciona a estos atributos):
 *   - data-cart-busy      → mutaciones del carrito (/cart/add|change|update|clear),
 *                            del tema o de las apps (packs, accesorios, regalos).
 *   - data-variant-loading → re-render de la ficha al cambiar de variante
 *                            (fetch a la sección con section_id + variant).
 *
 * Intercepta fetch Y XMLHttpRequest y nunca rompe la petición original.
 */
(function () {
  if (window.__criohCartBusy) return;
  window.__criohCartBusy = true;

  var root = document.documentElement;

  function makeTracker(attr, timeoutMs, clearDelay) {
    var inflight = 0;
    var safety = null;
    return {
      start: function () {
        inflight++;
        root.setAttribute(attr, '');
        if (safety) clearTimeout(safety);
        safety = setTimeout(function () {
          inflight = 0;
          root.removeAttribute(attr);
        }, timeoutMs);
      },
      end: function () {
        inflight--;
        if (inflight > 0) return;
        inflight = 0;
        if (safety) { clearTimeout(safety); safety = null; }
        setTimeout(function () {
          if (inflight <= 0) root.removeAttribute(attr);
        }, clearDelay);
      },
    };
  }

  var cart = makeTracker('data-cart-busy', 12000, 250);
  var variant = makeTracker('data-variant-loading', 8000, 120);

  var CART_MUTATION = /\/cart\/(add|change|update|clear)(\.js)?($|\?|\b)/i;
  function isVariantRerender(url) {
    // Horizon usa ?option_values=... al cambiar variante (también soportamos el
    // patrón antiguo section_id + variant por si acaso).
    if (/[?&]option_values=/i.test(url)) return true;
    return /[?&]section_id=/i.test(url) && /[?&]variant=/i.test(url);
  }
  function urlOf(a) {
    try {
      if (typeof a === 'string') return a;
      if (a && typeof a.url === 'string') return a.url;
    } catch (e) {}
    return '';
  }

  // --- fetch ---
  var origFetch = window.fetch;
  if (typeof origFetch === 'function') {
    window.fetch = function () {
      var url = urlOf(arguments[0]);
      var c = CART_MUTATION.test(url);
      var v = isVariantRerender(url);
      if (c) cart.start();
      if (v) variant.start();
      var p = origFetch.apply(this, arguments);
      if ((c || v) && p && typeof p.then === 'function') {
        var done = function () {
          if (c) cart.end();
          if (v) variant.end();
        };
        p.then(done, done);
      }
      return p;
    };
  }

  // --- XMLHttpRequest ---
  var origOpen = XMLHttpRequest.prototype.open;
  var origSend = XMLHttpRequest.prototype.send;
  XMLHttpRequest.prototype.open = function (method, url) {
    this.__criohCart = CART_MUTATION.test(url || '');
    this.__criohVariant = isVariantRerender(url || '');
    return origOpen.apply(this, arguments);
  };
  XMLHttpRequest.prototype.send = function () {
    var self = this;
    if (this.__criohCart) cart.start();
    if (this.__criohVariant) variant.start();
    if (this.__criohCart || this.__criohVariant) {
      this.addEventListener('loadend', function () {
        if (self.__criohCart) cart.end();
        if (self.__criohVariant) variant.end();
      });
    }
    return origSend.apply(this, arguments);
  };
})();
